module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Silver Aluminum + Light Pink Closed.54b71c16.png";